<template>
  <div id="app">
    <v-app>
      <v-main>
        <router-view :key="$route.fullPath" />
      </v-main>
    </v-app>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  methods: {
    onSeabayClick() {
      this.testUrl();
    },
    testUrl() {
      window.open("https://theseabay.com", "_blank");
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || "Seahub";
      },
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.v-main__wrap {
  background-color: #eeeeee;
}
</style>
